export default "__VITE_ASSET__B0blDUh7__";